<template>
  <router-link-modified :to="{name: 'vacancies'}"
                        class="base-btn base-btn--blue">
    <span class="base-btn__text">{{ text }}</span>
    <BaseSvg name="ico-arrow-light"/>
  </router-link-modified>

<!--  <router-link-modified v-if="isLogged"-->
<!--                        :to="{name: 'vacancies'}"-->
<!--                        class="base-btn base-btn&#45;&#45;blue">-->
<!--    <span class="base-btn__text">{{ text }}</span>-->
<!--    <BaseSvg name="ico-arrow-light"/>-->
<!--  </router-link-modified>-->
<!--  <button v-else-->
<!--          @click.prevent="$vModal.open('auth-before-find-work')"-->
<!--          class="base-btn base-btn&#45;&#45;blue">-->
<!--    <span class="base-btn__text">{{ text }}</span>-->
<!--    <BaseSvg name="ico-arrow-light"/>-->
<!--  </button>-->
</template>

<script>
  export default {
    name: 'HomePageSectionVacanciesBtn',
    props: {
      text: String
    },
    computed: {
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
    }
  }
</script>

<style lang="less">

</style>
